/*
 *
 * translation phrase marker
 *
 */
export default function (s) {
  return s
}
